import type { Theme } from '@mui/material';

import { muiSelectStyles } from 'src/theme/sharedStyles';

export const styles = {
  select: (theme: Theme) => ({
    ...muiSelectStyles.filterSelect(theme),
    flex: 0,
  }),

  menuProps: muiSelectStyles.filterPaper,

  menuItem: muiSelectStyles.filterMenuItem,
};
